import EqualityHashMap from '../util/EqualityHashMap'

const equalityHashMapStructuralSharing = <T>(oldData: T | undefined, newData: T): T =>
  oldData instanceof EqualityHashMap && newData instanceof EqualityHashMap && oldData.equals(newData)
    ? (oldData as T)
    : newData

export default equalityHashMapStructuralSharing
